import { Charts } from './Charts';
import EpidemiologyChartsDataProvider from './contexts/EpidemiologyChartsDataContext';

const EpidemiologyWrapper = () => {
    return (
        <EpidemiologyChartsDataProvider>
            <Charts />
        </EpidemiologyChartsDataProvider>
    );
};

export default EpidemiologyWrapper;